import * as React from "react";
import { UserRole } from "../../../../utils/types/user";
import BillersDashboard from "../../pages/Billers";
import OtherUsersDashboard from "../../pages/OtherUsers";
import { useAppSelector } from "../../../../hooks/useRedux";
import ProvidersDashboard from "../ProvidersDashboard/ProvidersDashboard";
import ProviderDashboard from "../ProviderDashboard/ProviderDashboard";
import {
    allowedUserIdsForDev,
    allowedUserIdsForProd,
} from "../../constants/constants.dashboard";
import { useFetchUserDetails } from "../../../../hooks/queries/user";

export default function DashboardToDisplay() {
    const { practice } = useAppSelector((state) => state.userPractice);

    const loggedInUser = useFetchUserDetails();

    const userIds =
        import.meta.env.VITE_NODE_ENV !== "production"
            ? allowedUserIdsForDev
            : allowedUserIdsForProd;

    const providerDashboardToDisplay = userIds.includes(
        loggedInUser?.data?.user_id || ""
    ) ? (
        <ProvidersDashboard />
    ) : (
        <ProviderDashboard />
    );

    return (
        <>
            {practice?.roles?.includes(UserRole.PROVIDER) &&
                providerDashboardToDisplay}
            {practice?.roles?.includes(UserRole.BILLER) && <BillersDashboard />}
            {!practice?.roles?.includes(UserRole.PROVIDER) &&
                !practice?.roles?.includes(UserRole.BILLER) && (
                    <OtherUsersDashboard />
                )}
        </>
    );
}
